import { Injectable } from '@angular/core';
import { TranslationService } from '../translation/translation.service';
import { Subject } from 'rxjs';
import { DialogModal } from './dialog-modal.model';
import { UtilService } from '../util/util.service';
import { IDialogService } from './idialog.service';

@Injectable()
export class DialogService implements IDialogService {
  public _translateService: TranslationService;
  public _utilService: UtilService;
  public _dialogs = new Subject<DialogModal>();
  public dialogAdded = this._dialogs.asObservable();

  public constructor(translateService: TranslationService, utilService: UtilService) {
    this._translateService = translateService;
    this._utilService = utilService;
  }

  public addDialog = (dialog: DialogModal) => {
    if (this._utilService.isNullEmptyOrWhitespace(dialog.headerText)) {
      dialog.headerText = this._translateService.getInstantTitlecase('common.confirmation');
    }
    if (this._utilService.isNullEmptyOrWhitespace(dialog.yesText)) {
      dialog.yesText = this._translateService.getInstantTitlecase('common.yes');
    }
    if (this._utilService.isNullEmptyOrWhitespace(dialog.noText)) {
      dialog.noText = this._translateService.getInstantTitlecase('common.no');
    }
    if (this._utilService.isNullEmptyOrWhitespace(dialog.cancelText)) {
      dialog.cancelText = this._translateService.getInstantTitlecase('common.cancel');
    }
    if (this._utilService.isNullEmptyOrWhitespace(dialog.okText)) {
      dialog.okText = this._translateService.getInstantTitlecase('common.ok');
    }

    this._dialogs.next(dialog);
  };

  public alert = (title: string, message: string) => {
    let dialog: DialogModal = new DialogModal();
    dialog.messageText = message;
    dialog.headerText = title;
    dialog.showAlert = true;
    dialog.show = true;
    this.addDialog(dialog);
  };

  public info = (info: string) => {
    let dialog: DialogModal = new DialogModal();
    dialog.messageText = info;
    dialog.headerText = this._translateService.getInstant('common.info');
    dialog.showAlert = true;
    dialog.show = true;
    this.addDialog(dialog);
  };

  public message = (message: string) => {
    let dialog: DialogModal = new DialogModal();
    dialog.messageText = message;
    dialog.headerText = this._translateService.getInstant('common.message');
    dialog.showAlert = true;
    dialog.show = true;
    this.addDialog(dialog);
  };

  public error = (error: any) => {
    const message = this._utilService.extractErrorMessage(error);
    let dialog: DialogModal = new DialogModal();
    dialog.messageText = message;
    dialog.headerText = this._translateService.getInstant('common.error');
    dialog.showAlert = true;
    dialog.show = true;
    dialog.isErrorDialog = true;
    this.addDialog(dialog);
  };

  public confirmYesNo = (message: string, yesFunction: Function, noFunction: Function) => {
    let dialog: DialogModal = new DialogModal();
    dialog.messageText = message;
    dialog.yesFunction = yesFunction;
    dialog.noFunction = noFunction;
    dialog.showCancel = false;
    dialog.show = true;
    this.addDialog(dialog);
  };

  public confirmDeleteStandardMessage = (deleteFunction: Function) => {
    let dialog: DialogModal = new DialogModal();
    dialog.messageText = this._translateService.getInstant('shared.dialog.standard-confirm-delete-phrase');
    dialog.yesFunction = deleteFunction;
    dialog.noFunction = null;
    dialog.showCancel = false;
    dialog.show = true;
    this.addDialog(dialog);
  };

  public confirmDeleteCustomMessage = (message: string, deleteFunction: Function) => {
    let dialog: DialogModal = new DialogModal();
    dialog.messageText = message;
    dialog.yesFunction = deleteFunction;
    dialog.noFunction = null;
    dialog.showCancel = false;
    dialog.show = true;
    this.addDialog(dialog);
  };

  public confirmYesNoCancel = (message: string, yesFunction: Function, noFunction: Function) => {
    let dialog: DialogModal = new DialogModal();
    dialog.messageText = message;
    dialog.yesFunction = yesFunction;
    dialog.noFunction = noFunction;
    dialog.show = true;
    this.addDialog(dialog);
  };

  public showWaitIndicator = () => {
    let dialog: DialogModal = new DialogModal();
    dialog.isWaitIndicator = true;
    dialog.show = true;
    this.addDialog(dialog);
  };

  public closeWaitIndicator = () => {
    let dialog: DialogModal = new DialogModal();
    dialog.isWaitIndicator = true;
    dialog.show = false;
    this.addDialog(dialog);
  };
}
